import React from "react";

export default function Loader() {
    return <p className="">Loading...</p>;
}
